import { StructuredText, StructuredTextGraphQlResponse, renderMarkRule } from "react-datocms";
import { isEmptyDocument } from "datocms-structured-text-utils";

type SiteBannerProps = {
  enabled: boolean;
  content: StructuredTextGraphQlResponse;
};

function SiteBanner({ content, enabled }: SiteBannerProps) {
  return enabled && !isEmptyDocument(content) ? (
    <div className="bg-stealth-bomber text-white px-7 py-4 flex justify-center text-center">
      <StructuredText
        data={content}
        customMarkRules={[
          renderMarkRule("strong", ({ children, key }) => {
            return (
              <strong key={key} className="font-medium">
                {children}
              </strong>
            );
          }),
        ]}
      />
    </div>
  ) : null;
}

export { SiteBanner };
